var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component/icon/ic_Reload"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconspace_Refresh_25px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.8335 3.7258C3.8335 3.32495 4.15512 3 4.55187 3C4.94862 3 5.27025 3.32495 5.27025 3.7258V5.25454C7.47286 2.9769 10.9204 2.32651 13.8302 3.76042C17.5143 5.57582 19.0442 10.0649 17.2474 13.787C15.4505 17.5091 11.0074 19.0548 7.32332 17.2394C5.85198 16.5144 4.67409 15.3351 3.94515 13.8673C3.76723 13.509 3.91046 13.0728 4.26507 12.8931C4.61969 12.7133 5.0514 12.858 5.22932 13.2163C5.81725 14.4002 6.76558 15.3495 7.95315 15.9347C10.924 17.3987 14.507 16.1522 15.956 13.1507C17.405 10.1491 16.1713 6.52906 13.2004 5.0651C10.5954 3.78143 7.48583 4.57703 5.78799 6.87093H8.38321C8.77996 6.87093 9.10159 7.19588 9.10159 7.59672C9.10159 7.99757 8.77996 8.32252 8.38321 8.32252H4.55187C4.15512 8.32252 3.8335 7.99757 3.8335 7.59672V7.54221C3.83333 7.53059 3.8335 3.7258 3.8335 3.7258Z",
    fill: "#4B4AD5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcReload);
export default __webpack_public_path__ + "static/media/ic_Reload.7d78302b0dd3ee86e0dbd64858a644dd.svg";
export { ForwardRef as ReactComponent };